import { Box, Button, Text, VStack } from '@televet/kibble-ui';
import React from 'react';
import { useModularity } from 'shared/hooks/useModularity';

const RecapFlowUpgradeBanner = (): JSX.Element | null => {
  const { isRecapClinic, isSubscriptionActive } = useModularity();

  if (!isRecapClinic) {
    return null;
  }

  return (
    <VStack
      align="flex-start"
      spacing={2}
      py={2}
      px={3}
      borderRadius="md"
      bg="linear-gradient(85deg, #E5F9C6 0%, #E9F2FF 100%)"
    >
      <Box>
        <Text as="p" fontWeight="bold">
          {isSubscriptionActive ? 'Enjoying AI Recap?' : 'Enjoyed AI Recap?'}
        </Text>
        <Text as="p">{'See what Flow can do for your clinic.'}</Text>
      </Box>
      <Button
        iconName="star"
        size="xs"
        variant="primary"
        bg="text.interactive"
        _hover={{ bg: 'text.interactive.hover' }}
        _active={{ bg: 'text.interactive.hover' }}
        onClick={(): void => {
          window.open(
            'https://otto.vet/otto-flow/?utm_source=otto+ai+&utm_medium=referral&utm_campaign=otto+flow',
            '_blank',
          );
        }}
      >
        Learn More
      </Button>
    </VStack>
  );
};

export default RecapFlowUpgradeBanner;
